import React from 'react'

const Manager = () => {
  return (
    <div>
      <h2>managers</h2>
    </div>
  )
}

export default Manager
